module.exports = __webpack_public_path__ + "img/1096015467.b8968145.svg";